import { AfterViewInit, ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule, NgIf } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOption } from '@angular/material/core';
import { MatDatepickerToggle, MatDatepicker, MatDatepickerInput } from '@angular/material/datepicker';
import { MatExpansionModule, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSelect } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CookieService } from 'ngx-cookie-service';
import { finalize, sample, tap } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { AnalyseService } from '../../../../services/analyse-service/analyse.service';
import { HandleErrorsService } from '../../../../services/handle-erros/handle.errors.service';
import { MatriceService } from '../../../../services/matrice-service/matrice.service';
import { ParametreService } from '../../../../services/parametre-service/parametre.service';
import { SampleStatusService } from '../../../../services/sample-status-service/sample.status.service';
import { TypeAnalyseService } from '../../../../services/type-analyse-service/type.analyse.service';
import { DialogService } from '../../../_modal/dialog.service';
import { ApiService } from '../../../_services/api.service';
import { Endpoints } from '../../../endpoints';
import { ClientsService } from '../../../../services/client-service/clients.service';
import { LotService } from '../../../../services/lot-service/lot.service';
import { SampleService } from '../../../../services/sample-service/sample.service';
import { TerrrainService } from '../../../../services/terrains-service/terrrain.service';
import { UserService } from '../../../../services/user-service/user.service';
import { ShortClientDto } from '../../../_models/client.dtos';
import { LotDto } from '../../../_models/LotDto';
import { PrelevementSampleView, SampleStatus, PrelevementSampleDto, ReceptionSampleDto } from '../../../_models/sampleDTO';
import { TerrainDTO } from '../../../_models/terrain.dto';
import { typeSampleDTO, ProductData } from '../../../_models/typeSampleDTO';
import { AppUserDTO } from '../../../_models/userDTO';
import { MatriceDTO } from '../../../_models/MatriceDTO';
import { TypeAnalyseDTO } from '../../../_models/typeAnalyseDTO';
import { ParameterDTO } from '../../../_models/ParameterDTO';
import { ShortTypeAnalyseDto } from '../../../_models/type.analyse.dtos';
import { ShortMatriceDto } from '../../../_models/matrice.dtos';


@Component({
  standalone:true,
  selector: 'app-reception',
  templateUrl: './reception.component.html',
  providers: [TerrrainService,AnalyseService, ParametreService, TypeAnalyseService, ApiService, Endpoints, DialogService, MatriceService, SampleService, HandleErrorsService, ClientsService, SampleStatusService,ApiService, Endpoints],
  imports: [MatExpansionModule,
      MatNativeDateModule,
      CommonModule,FormsModule,
MatAutocompleteModule,

      MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
      MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,MatChipsModule,
      MatSuffix, MatSortModule, MatInputModule, MatOption,MatIconModule, MatSelect, MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatCheckbox, MatProgressSpinner, MatTab, MatTabGroup, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription
  ],
  styleUrls: ['./reception.component.scss']
})
export class ReceptionComponent implements OnInit, OnChanges, AfterViewInit  {

  form: FormGroup;
  showForm: boolean = false;
  content: any;
  samples: any[] = [];
  searchVal: string = ''
  loadingTable: boolean = true;

  sampleTypeControl = new FormControl<string>('');
  dataSource: MatTableDataSource<ReceptionSampleDto> = new MatTableDataSource<ReceptionSampleDto>();

  clientList: ShortClientDto[] = [];
  typeStList: typeSampleDTO[] = [];
  terrainList: TerrainDTO[] = [];
  filteredTerrains: TerrainDTO[] = [];
  lotList: LotDto[] = [];
  preleveurs: AppUserDTO[] = [];
  productList: ProductData[] = [];
  filteredProducts: ProductData[] = [];
  typeAnalyseList: ShortTypeAnalyseDto[] = []
  
  sampleTypes: string[] = [];
  selectedSampleType!: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('editModal') editModal: TemplateRef<any>;
  @ViewChild('viewModal') viewModal: TemplateRef<any>;
  selectedClientId: number | null = null;
  selectedLotId: number | null = null;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataSource']) {
        this.initializeForm();
    }
}

initializeForm() {
  this.form = this.fb.group({
    id: [null, Validators.required],                // échantillon sélectionné
    temperatureReception: [''],
    referenceInterne: [''],
    sampleCondition: [''],
    storageConditions: [''],
    remarques: [''],
    dateReception: [''],
    matriceId: [null, Validators.required],
    typeAnalyseId: [null, Validators.required]
});

}
    paramList: ParameterDTO[] = []
    matriceList: ShortMatriceDto[] = []



  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private apiService: ApiService,
    private endpoints: Endpoints,
    private cdr: ChangeDetectorRef,
    private sampleService:SampleService,
    private lotService: LotService,
    private clientService: ClientsService,
    private terrainService: TerrrainService,
    private userService: UserService,
    private cookieService: CookieService,
    private dialogService: DialogService,
    public themeService: CustomizerSettingsService,
    private parametreService : ParametreService,
    private overlayContainer: OverlayContainer,
    private matriceService:MatriceService,
    private parameterService:ParametreService,
    private typeAnalyseService: TypeAnalyseService,
    private handleErrors: HandleErrorsService) {
  }
  displayedColumns: string[] = [
    'sampleCode',
    'clientName',
    'batchName',
    'typeAnalyseName',
    'matriceName',
    'temperatureReception',
    'referenceInterne',
    'dateReception',
    'sampleCondition',
    'storageConditions',
    'remarques',
    'action'
  ];

  
  columns: string[] = [...this.displayedColumns];

  ngOnInit(): void {
    this.loadReceptions();
    this.fetchClientList();
    this.fetchLotList();
    this.loadPreleveurs();
    this.loadProducts();
    this.initializeForm();
    this.fetchMatriceList();
    this.loadPrelevementSamples();
    this.sampleService.fetchSampleTypes().subscribe((types: string[]) => {
      this.sampleTypes = types;
  });
    // Filtrage dynamique des produits pour autocomplete
    this.sampleTypeControl.valueChanges.subscribe(value => {
      if (value) {
        this.filteredProducts = this.productList.filter(p =>
          p.productName.toLowerCase().includes(value.toLowerCase())
        );
      } else {
        this.filteredProducts = [];
      }
    });
    this.form.get('clientId')?.valueChanges.subscribe(clientId => {
      if (clientId) {
        this.fetchTerrainList(clientId);
      } else {
        this.filteredTerrains = [];
      }
    });
  }

  applyFilter(event: Event) {
    this.searchVal = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = this.searchVal
}
onSelectionChange(column: string): void {
  if (this.displayedColumns.includes(column)) {
      this.displayedColumns = this.displayedColumns.filter(c => c !== column);
  } else {
      this.displayedColumns.push(column)
  }
  this.setColsCookie()
}  

  private fetchMatriceList() {
      this.matriceService.fetchmatriceList().subscribe({
          next: responce => responce.status ? this.matriceList = responce.data : null,
      })
  }
loadReceptions() {
  console.log('🔄 Chargement des samples avec statut RECEPTION...');

  this.sampleService.getSamplesByStatus(SampleStatus.RECEPTION).subscribe({
    next: (data: any[]) => {
      console.log('✅ Réponse reçue :', data);

      if (!Array.isArray(data) || data.length === 0) {
        console.warn('⚠️ Aucun sample en statut RECEPTION');
        this.samples = [];
        this.dataSource.data = [];
        return;
      }

      this.samples = data;

      // Mapping pour que les noms correspondent aux colonnes de la table
      const mappedSamples = data.map(sample => ({
        id: sample.id,
        sampleCode: sample.sampleCode ?? '-',
        typeSampleName: sample.sampleType ?? sample.typeSampleName ?? '-',
        clientId: sample.client?.id ?? sample.clientId ?? null,
        clientName: sample.client?.socialReason ?? sample.clientName ?? '-',
        batchId: sample.batchId ?? null,
        batchName: sample.batchName ?? '-',
        terrainId: sample.terrain?.id ?? sample.terrainId ?? null,
        terrainVarPlante: sample.terrain?.varPlante ?? sample.terrainVarPlante ?? '-',
        collectedById: sample.collectedBy?.id ?? sample.collectedById ?? null,
        collectedByUsername: sample.collectedBy?.username ?? sample.collectedByUsername ?? '-',
        qtePre: sample.qtePre ?? null,
        collectionDate: sample.collectionDate ?? null,
        dateReception: sample.dateReception ?? null,

        // Pour table
        typeAnalyseName: sample.typeAnalyseName ?? sample.typeAnalyse?.codeAT ?? '-',
        matriceName: sample.matriceName ?? '-',
        temperatureReception: sample.temperatureReception ?? '-',
        remarques: sample.remarques ?? '-',
        referenceInterne: sample.referenceInterne ?? '-',
        sampleCondition: sample.sampleCondition ?? '-',
        storageConditions: sample.storageConditions ?? '-',
        // Pour DTO
        typeAnalyseId: sample.typeAnalyse?.id ?? sample.typeAnalyseId ?? null,
        matriceId: sample.matrice?.id ?? sample.matriceId ?? null
      }));

      console.log('📊 Données mappées :', mappedSamples);

      this.dataSource.data = mappedSamples;

      if (this.sort) this.dataSource.sort = this.sort;
      if (this.paginator) this.dataSource.paginator = this.paginator;

      console.log('🎉 Samples RECEPTION chargés avec succès');
    },

    error: err => {
      console.error('❌ Erreur chargement RECEPTION :', err);
    }
  });
}

trackByFn(index: number, item: any): any {
  return item.id; // ou item.codeParameter selon ce que tu veux comme identifiant unique
}


  // --- Clients ---
  fetchClientList() {
    this.clientService.loadClients().subscribe({
      next: (res: { status: any; data: ShortClientDto[]; }) => {
        if (res.status) this.clientList = res.data;
      },
      error: (err: any) => console.error('❌ Erreur clients :', err)
    });
  }
  openModal(content: any) {
    this.form.reset()
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then(
        (result) => {
            if (result === 'save') {
            }
        }
    );
}

    fetchTypeAnalyseList(matriceId?: number) {
        this.paramList = []
        this.typeAnalyseService.fetchTypeAnalyseList(matriceId ? matriceId : this.form.value.matriceId).subscribe({
            next: responce => responce.status ? this.typeAnalyseList = responce.data : console.log(responce.message),
            error: err => this.handleErrors.catchError(err)
        })
    }

  // --- Lots ---
  fetchLotList() {
    this.lotService.getAllBatches().subscribe({
      next: (res: LotDto[]) => this.lotList = res,
      error: (err: any) => console.error('❌ Erreur lots :', err)
    });
  }

  // --- Terrains filtrés par client ---
  fetchTerrainList(clientId: number) {
    this.terrainService.findAll().subscribe({
      next: (res: { status: any; data: TerrainDTO[]; }) => {
        if (res.status) {
          this.terrainList = res.data;
          this.filteredTerrains = this.terrainList.filter(t => Number(t.clientId) === Number(clientId));
          console.log('Terrains filtrés pour le client', clientId, ':', this.filteredTerrains);
        }
      },
      error: (err: any) => console.error('Erreur terrains :', err)
    });
  }
  
  // --- Préleveurs ---
  loadPreleveurs() {
    this.userService.getUsers().subscribe({
      next: (res: { status: any; data: any[]; }) => {
        if (res.status) {
          this.preleveurs = res.data.filter((u: { roles: any; }) => {
            const roles = Array.isArray(u.roles) ? u.roles : [u.roles];
            return roles.includes('ROLE_PRELEVEUR');
          });
        }
      },
      error: (err: any) => console.error('❌ Erreur préleveurs :', err)
    });
  }

  // --- Produits ---
  loadProducts() {
    this.sampleService.getAllProducts().subscribe((data: ProductData[]) => this.productList = data);
  }

  toggleForm() {
    this.showForm = !this.showForm;
  }

updateReception() {
  console.log('📌 updateReception() appelé');

  if (!this.form.valid) {
    console.warn('⚠️ Formulaire invalide, vérifier les champs requis');
    console.log('💡 Valeurs actuelles:', this.form.value);
    return;
  }

  const dto: ReceptionSampleDto = {
    id: this.form.value.id,
    typeAnalyseId: this.form.value.typeAnalyseId,
    matriceId: this.form.value.matriceId,
    temperatureReception: this.form.value.temperatureReception || '',
    referenceInterne: this.form.value.referenceInterne || '',
    sampleCondition: this.form.value.sampleCondition || '',
    storageConditions: this.form.value.storageConditions || '',
    remarques: this.form.value.remarques || '',
    dateReception: this.form.value.dateReception
      ? new Date(this.form.value.dateReception).toISOString()
      : ''
  };


  console.log('📦 DTO pour updateReception :', dto);

  const sampleId = this.form.value.id;

  this.sampleService.updateReception(sampleId, dto).subscribe({
    next: (res: any) => {
      console.log('✅ Réception mise à jour avec succès', res);
      this.modalService.dismissAll(); 
      this.cdr.detectChanges(); 
      this.dialogService.openSuceessAlert('Réception enregistrée avec succès');  
      this.loadReceptions(); // recharge la liste des réceptions
    },
    error: (err: any) => {
      console.error('❌ Erreur lors de la mise à jour de la réception', err);
    }
  });
}

    onLotChange(batchId: number | null) {
    if (batchId) {
      const selectedLot = this.lotList.find(l => l.id === batchId);
      if (selectedLot) {
        this.selectedLotId = selectedLot.id;
        this.selectedClientId = selectedLot.clientId;
        this.form.patchValue({
          batchId: selectedLot.id,
          clientId: selectedLot.clientId
        });
        this.form.get('batchId')?.disable();
        this.form.get('clientId')?.disable();
        this.fetchTerrainList(this.selectedClientId);
      }
    } else {
      this.selectedLotId = null;
      this.selectedClientId = null;
      this.form.get('batchId')?.enable();
      this.form.get('clientId')?.enable();
    }
  }

  // --- Sélection d'un produit ---
  onProductSelected(product: ProductData) {
    this.form.get('typeSample')?.setValue(product.id);
    this.sampleTypeControl.setValue(product.productName, { emitEvent: false });
  }
  prelevementSamples: any[] = [];

loadPrelevementSamples() {
  this.sampleService.getSamplesByStatus(SampleStatus.PRELEVEMENT).subscribe({
    next: (samples) => {
      this.prelevementSamples = samples; // variable utilisée dans le mat-select
      console.log('Samples PRELEVEMENT:', samples);
    },
    error: (err) => console.error('Erreur chargement PRELEVEMENT:', err)
  });
}

  typeAnalyses: TypeAnalyseDTO[] = [];
  matrices: MatriceDTO[] = [];

submitReception() {
  console.log('🔹 submitReception déclenché');
  console.log('Formulaire actuel:', this.form.value);

  if (!this.form.valid) {
    console.warn('⚠️ Formulaire invalide, vérifier les champs requis');
    console.log('Champs invalides:', this.form.controls);
    return;
  }

  console.log('✅ Formulaire valide, préparation du DTO...');

  const dto: ReceptionSampleDto = {
    id: this.form.value.id,  // formControlName="id"
    typeAnalyseId: this.form.value.typeAnalyseId || null,  // ⚡ si vide, null
    matriceId: this.form.value.matriceId || null,          // ⚡ si vide, null
    temperatureReception: this.form.value.temperatureReception || null,
    referenceInterne: this.form.value.referenceInterne || '',
    sampleCondition: this.form.value.sampleCondition || '',
    storageConditions: this.form.value.storageConditions || '',
    remarques: this.form.value.remarques || null,
    dateReception: this.form.value.dateReception || null,  // ⚡ null si non rempli
  };


  console.log('📦 DTO prêt à être envoyé :', dto);

  this.sampleService.receiveSample(dto.id, dto).subscribe({
    next: (res: any) => {
      console.log('✅ Réponse du service reçue :', res);
      this.modalService.dismissAll();
      this.cdr.detectChanges();
      this.dialogService.openSuceessAlert('Réception enregistrée avec succès');
      this.loadReceptions(); // recharge la table des réceptions
    },
    error: (err: { error: any }) => {
      console.error('❌ Erreur lors de la réception :', err);
      if (err.error) console.error('💡 Détails de l’erreur:', err.error);
    }
  });
}

  removeTableRow(id: number) {
    this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
}
  // --- Supprimer un prélèvement ---
  deleteSample(id: number) {
    this.apiService.delete(id, this.endpoints.sampler_base_endpoint + '/delete_sample').pipe(
        tap((response: any) => {
            console.log('Réponse de suppression :', response); // ✅ Console ajoutée

            if (response.status) {
                this.removeTableRow(id);
                this.dialogService.openSuceessAlert('Échantillon supprimé avec succès');
            } else {
                this.dialogService.openDangerAlert(response.message || 'Suppression échouée');
            }
        }),
        finalize(() => {
            this.dataSource.paginator = this.paginator;
        })
    ).subscribe({
        error: (err) => {
            console.error('Erreur lors de la suppression :', err); // ✅ Console ajoutée
            this.dialogService.openDangerAlert(err.error.message || 'Erreur serveur');
        }
    });
}
async openViewSample(sample: any) {
  // Charger la liste des types si vide
  if (!this.typeAnalyseList.length && sample.matriceId) {
    try {
      const res = await this.typeAnalyseService.fetchTypeAnalyseList(sample.matriceId).toPromise();
      
      // Vérification que res est défini
      if (res && res.status) {
        this.typeAnalyseList = res.data ?? [];
      } else {
        console.warn('⚠️ Aucun type d’analyse reçu ou status = false', res);
      }
    } catch (err) {
      console.error('❌ Erreur lors du chargement des types d’analyse', err);
    }
  }
  // Patch du formulaire
  this.form.patchValue({
    id: sample.id,
    typeAnalyseId: sample.typeAnalyseId,
    matriceId: sample.matriceId,
    temperatureReception: sample.temperatureReception,
    referenceInterne: sample.referenceInterne,
    sampleCondition: sample.sampleCondition,
    storageConditions: sample.storageConditions,
    dateReception: sample.dateReception,
    remarques: sample.remarques,
  });

  console.log("📝 Etat du form APRÈS :", this.form.value);

  this.modalService.open(this.viewModal, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
}


  // Récupérer le nom du type d'analyse depuis son ID
  getTypeAnalyseNameById(id: number | null | undefined): string {
    if (id == null) return '-';

    if (!this.typeAnalyseList.length) {
      console.warn('⚠️ La liste des types d’analyse est vide !');
      return '-';
    }

    const type = this.typeAnalyseList.find(t => t.id === id);

    if (!type) {
      console.warn(`⚠️ Aucun type d'analyse trouvé pour l'id ${id}`);
      return '-';
    }

    return type.codeAT ?? '-';
  }


    // Récupérer le nom de la matrice depuis son ID
    getMatriceNameById(id: number): string {
      const mat = this.matriceList.find(m => m.id === id);
      return mat ? mat.nom : '-';
    }

  
    fetchParametres(id?: number) {
        let typeAnalyseId: number = id ? id : this.form.value.typeAnalyseId;
        let matriceId: number = this.form.value.matriceId;
    
        console.log("Fetching parameters for TypeAnalyse ID:", typeAnalyseId, "and Matrice ID:", matriceId);
        
        this.parametreService.fetchParametreList(typeAnalyseId).subscribe({
            next: response => {
                console.log("Response received:", response);
                if (response.status) {
                    this.paramList = response.data; // Met à jour paramList avec les nouveaux paramètres
                    console.log("Updated paramList:", this.paramList);
                }
            },
            error: err => {
                console.error("Error fetching parameters:", err);
                this.handleErrors.catchError(err);
            }
        });
    }
    
  editReception(sample: any) {
  console.log("Réception sélectionnée pour modification :", sample);

  // Charger la liste des types d'analyse selon la matrice
  this.fetchTypeAnalyseList(sample.matriceId);

  let dateReceptionValue: string | null = null;

  if (sample.dateReception) {
    const date = new Date(sample.dateReception);
    if (!isNaN(date.getTime())) {
      // Format 'yyyy-MM-ddTHH:mm' requis par datetime-local
      const pad = (n: number) => n.toString().padStart(2, '0');
      const yyyy = date.getFullYear();
      const mm = pad(date.getMonth() + 1);
      const dd = pad(date.getDate());
      const hh = pad(date.getHours());
      const min = pad(date.getMinutes());
      dateReceptionValue = `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    }
  }
  this.form.patchValue({
    id: sample.id,
    sampleCode: sample.sampleCode || '',

    // IDs réels pour les mat-select
    typeAnalyseId: sample.typeAnalyseId || null,
    matriceId: sample.matriceId || null,

    clientId: sample.clientId || null,
    batchId: sample.batchId || null,
    terrainId: sample.terrainId || null,
    collectedById: sample.collectedById || null,

    // Champs d’affichage pour montrer le nom si besoin
    clientName: sample.clientName || '',
    batchName: sample.batchName || '',
    terrainVarPlante: sample.terrainVarPlante || '',
    collectedByUsername: sample.collectedByUsername || '',

    temperatureReception: sample.temperatureReception || '',
    referenceInterne: sample.referenceInterne || '',
    sampleCondition: sample.sampleCondition || '',
    storageConditions: sample.storageConditions || '',
    dateReception: dateReceptionValue,
    remarques: sample.remarques

  });

  console.log("Formulaire après patchValue pour réception :", this.form.value);

  this.modalService.open(this.editModal, { size: 'lg' });
}

  
confirmDelete(element: any) {
  this.dialogService.open('Vous etes sur de supprimer cet échantillon?', environment.warning_message_type, 'danger', environment.warning_icon, true)
      .then((result: any) => {
          if (result) {
              this.deleteSample(element.id);
          }
      });
}
user_name = sessionStorage.getItem('user_name');

private setColsCookie() {
  this.cookieService.set(`prelCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
      expires: 7,
      path: '/',
      secure: true
  });
}
private getColsCookie() {
  const sampleCols = this.cookieService.get(`prelCol_${this.user_name}`); // Get the cookie value

  if (sampleCols) {
      this.displayedColumns = JSON.parse(sampleCols); // Convert the JSON string back to an object
      console.log('Retrieved object:', sampleCols);


}
}

handleIsAllColsSelected(event: MatCheckboxChange) {
  if (event.checked) {
      this.displayedColumns = [...this.columns]
  } else {
      this.displayedColumns = []
  }
  this.setColsCookie()
}

getdisplayedCol = (): string[] => {
  return ['select', ...this.displayedColumns, 'action']
};

ngAfterViewInit() {
  this.initializePaginatorAndSort()
}

initializePaginatorAndSort() {
  this.overlayContainer.getContainerElement().style.zIndex = '2000';
  this.dataSource.filter = this.searchVal
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;
  this.sort.active = 'id';
  this.sort.direction = 'desc';

}

validateSample(sample: any, accept: boolean = true, comments?: string) {
  console.log('✅ Validation de l’échantillon :', sample);

  const dto = {
    id: sample.id,
    accept: accept,
    comments: comments ?? ''
  };

  this.sampleService.validateSample(dto).subscribe({
    next: res => {
      console.log('Sample validé avec succès', res);
      this.dialogService.openSuceessAlert('Échantillon validé avec succès');
      this.loadReceptions(); // rafraîchir la liste
    },
    error: err => {
      console.error('Erreur lors de la validation', err);
    }
  });
}
// Méthode pour rejeter un échantillon
rejectSample(sample: any, comments?: string) {
  console.log('❌ Rejet de l’échantillon :', sample);

  const dto = {
    id: sample.id,
    accept: false,          // <-- false pour rejet
    comments: comments ?? '' // optionnel
  };

  this.sampleService.validateSample(dto).subscribe({
    next: res => {
      console.log('Sample rejeté avec succès', res);
      this.loadReceptions(); // rafraîchir la liste
    },
    error: err => {
      console.error('Erreur lors du rejet', err);
    }
  });
}


}


